// Imports Angular
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/** @namespace ContenedorFormularioComponent */
import { ContenedorFormularioComponent } from './components/formulario/contenedor-formulario/contenedor-formulario.component';

/**
 * Routes associated to components
 * @constant
 * @type {Array<JSON>}
 */
const routes: Routes = [
	{ path: '', component: ContenedorFormularioComponent },
    { path: 'formulario', component: ContenedorFormularioComponent }
];

/** @module NgModule main app */
@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ],
    providers: []
})

/**
* Module main app routing
* @class
*/
export class AppRoutingModule { }



// WEBPACK FOOTER //
// D:/GIT/F300/V4/ng_formulario300v4/src/app/app-routing.module.ts